module.exports = __webpack_public_path__ + "img/logo@2x.1a577ef4.png";